// extracted by mini-css-extract-plugin
module.exports = {"button":"language-selector-button_button__4lXYs"};